import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import * as AppActions from '../../AppActions';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import Theme from '../../Theme';
import * as Ant from 'antd';

const pageSize = 20;
const collectionName = 'job';

function NewsJobs(props) {
  const [paging, setPaging] = React.useState({offset: 0, limit: pageSize});
  const [fetchResp, setFetchResp] = React.useState(null);

  const fetchDocumentList = React.useCallback(async () => {
    AppActions.setLoading(true);
    try {
      const today = new Date().toLocaleDateString('sv');
      const extraQuery = {
        status: '通過',
        start_date: {
          $lte: today,
        },
        end_date: {
          $gte: today,
        },
      };
      const resp = await JStorage.fetchDocuments(
        collectionName,
        extraQuery,
        ['-date'],
        paging,
      );

      setFetchResp(resp);
    } catch (ex) {
      console.warn(ex);
    }
    AppActions.setLoading(false);
  }, [paging]);

  React.useEffect(() => {
    async function fetchData() {
      fetchDocumentList();
    }

    fetchData();
  }, [fetchDocumentList]);

  return (
    <Wrapper>
      <h1 style={{fontSize: 28}}>徵才看板</h1>

      <Ant.Table
        columns={[
          {
            title: '刊登日期',
            key: 'date',
            width: 120,
            render: (_, record) => {
              return (
                <div>
                  <div>開始: {record.start_date}</div>
                  <div>結束: {record.end_date}</div>
                </div>
              );
            },
          },
          {
            title: '標題',
            key: 'title',
            render: (_, record) => {
              return (
                <div>
                  <div>{record.title}</div>
                </div>
              );
            },
          },
          {
            title: '單位',
            key: 'unit',
            dataIndex: 'unit',
          },
          {
            title: '要求學歷/科系',
            key: 'education',
            dataIndex: 'education',
          },
          {
            title: '工作地點',
            key: 'location',
            dataIndex: 'location',
          },
          {
            title: '年資',
            key: 'year',
            dataIndex: 'year',
          },
          {
            title: '徵才連結',
            key: 'link',
            render: (_, record) => {
              if (record.link) {
                return (
                  <Ant.Button type="link" href={record.link} target="_blank">
                    徵才連結
                  </Ant.Button>
                );
              }
              return '';
            },
          },
        ]}
        dataSource={fetchResp?.results}
        rowKey={'id'}
        pagination={{
          size: 'small',
          total: fetchResp?.total || 0,
          showSizeChanger: false,
          showTotal: (total) => `共 ${total} 筆, 每頁 ${pageSize} 筆`,
          current: paging.offset / pageSize + 1,
          pageSize: pageSize,
          position: ['bottomCenter'],
          onChange: (page, pageSize) => {
            if (pageSize) {
              setPaging({
                offset: (page - 1) * pageSize,
                limit: pageSize,
              });
            }
          },
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  h1 {
    text-align: center;
    padding-bottom: 15px;
    border-bottom: 4px solid ${Theme.colors.main};
    margin-bottom: 25px;
  }
`;

export default withPageEntry(NewsJobs);
